// comunicacion.service.ts
// Se recomienda hacerlo asi y no con event emitters para evitar problemas de memoria
// y fugas de memoria en aplicaciones grandes.
// podemos ir pasando aqui los event emitters.

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'; // Importa Subject

@Injectable({
    providedIn: 'root'
})
export class InterComunicacionService {

    private swipeUpEmit = new Subject<void>();

    public datos$ = this.swipeUpEmit.asObservable();

    swipeUp() {
        this.swipeUpEmit.next();
    }
}